import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=083616b0"
import script from "./SystemMessage.vue?vue&type=script&lang=js"
export * from "./SystemMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports